import { HStack, Heading } from "@chakra-ui/react";

function LoonieIcon({ size = 24 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="
          M 100.0 18.0
          A 162.3 162.3 0 0 1 144.3 31.0
          A 162.3 162.3 0 0 1 174.6 65.9
          A 162.3 162.3 0 0 1 181.2 111.7
          A 162.3 162.3 0 0 1 162.0 153.7
          A 162.3 162.3 0 0 1 123.1 178.7
          A 162.3 162.3 0 0 1 76.9 178.7
          A 162.3 162.3 0 0 1 38.0 153.7
          A 162.3 162.3 0 0 1 18.8 111.7
          A 162.3 162.3 0 0 1 25.4 65.9
          A 162.3 162.3 0 0 1 55.7 31.0
          A 162.3 162.3 0 0 1 100.0 18.0
          Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="8"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Logo({ size = "sm" }: { size?: "sm" | "lg" }) {
  const iconSize = size === "lg" ? 40 : 22;
  const headingSize = size === "lg" ? "3xl" : "md";

  return (
    <HStack gap={size === "lg" ? "3" : "2"} color="loonie.fg" asChild>
      <a href="/" style={{ textDecoration: "none" }}>
        <LoonieIcon size={iconSize} />
        {/* A span, not a heading: the wordmark repeats on every page and would
            otherwise compete with each page's own <h1>. */}
        <Heading as="span" size={headingSize} color="fg">
          Loonie
        </Heading>
      </a>
    </HStack>
  );
}
